import React from "react";
import styles from "../../../assets/styles/Competition/Competition.module.scss";
import {
  MimaButton,
  MimaDateInput,
  MimaDropdown,
  MimaInput,
  MimaText,
  MimaTextArea,
  Modal,
  ReactQuillInput,
} from "../../../components";
import { Formik, FieldArray } from "formik";

const EditCompetition = ({
  closeModal,
  onSubmit,
  validationSchema,
  loading,
  currencyCodes,
  selectedCompetition,
}) => {
  const statusData = [
    { key: "ACTIVE", value: "ACTIVE" },
    { key: "INACTIVE", value: "INACTIVE" },
  ];

  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" mb={4}>
        Edit Competition
      </MimaText>
      <Formik
        initialValues={{
          winningAmount: selectedCompetition?.winningAmount || 0,
          name: selectedCompetition?.name || "",
          subTitle: selectedCompetition?.subTitle || "",
          instagramLink: selectedCompetition?.instagramLink || "",
          twitterLink: selectedCompetition?.twitterLink || "",
          registrationStartDate:
            new Date(selectedCompetition?.registrationStartDate) || "",
          registrationEndDate:
            new Date(selectedCompetition?.registrationEndDate) || "",
          stageOneVotingStartDate:
            new Date(selectedCompetition?.stageOneVotingStartDate) || "",
          stageTwoVotingStartDate:
            new Date(selectedCompetition?.stageTwoVotingStartDate) || "",
          stageTwoVotingEndDate:
            new Date(selectedCompetition?.stageTwoVotingEndDate) || "",
          stageOneVotingEndDate:
            new Date(selectedCompetition?.stageOneVotingEndDate) || "",
          description: selectedCompetition?.description || "",
          summary: selectedCompetition?.summary || "",
          referrers: selectedCompetition?.referrers || [""],
          currencyCode: selectedCompetition?.currencyCode || "",
          status: selectedCompetition.status || "",
          prizes:
            selectedCompetition.prizes.length > 0
              ? selectedCompetition.prizes
              : [
                  {
                    prize: 1,
                    title: "",
                    prizeKey1: "",
                    prizeKey2: "",
                    prizeKey3: "",
                    prizeValue1: "",
                    prizeValue2: "",
                    prizeValue3: "",
                  },
                ],
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
        }) => (
          <>
            <MimaInput
              labelTitle="Competition Name"
              name="name"
              value={values.name}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.name}
              touched={touched.name}
            />
            <MimaTextArea
              labelTitle="Competition Summary"
              name="summary"
              placeholder="Enter Summary"
              value={values.summary}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.summary}
              touched={touched.summary}
            />

            <MimaInput
              labelTitle="Subtitle"
              name="subTitle"
              value={values.subTitle}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.subTitle}
              touched={touched.subTitle}
            />

            <ReactQuillInput
              name="description"
              labelTitle="Competition Description"
              error={errors.description}
              touched={touched.description}
              placeholder="Enter Description"
              width={38}
              mt={2}
              mb={5}
            />

            {/* <MimaTextArea
              labelTitle="Competition Description"
              name="description"
              placeholder="Enter Description"
              value={values.description}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.description}
              touched={touched.description}
            /> */}

            <div className={styles.beside}>
              <MimaInput
                labelTitle="Total Prize"
                name="winningAmount"
                value={values.winningAmount}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.winningAmount}
                touched={touched.winningAmount}
                width={18}
                type="number"
              />
              <MimaDropdown
                labelTitle="Currency"
                placeholder={selectedCompetition.currencyCode}
                name="currencyCode"
                data={currencyCodes}
                value={values.currencyCode}
                id="currencyCode"
                onChange={(data) => {
                  setFieldValue("currencyCode", data.key);
                }}
                error={errors.currencyCode}
                touched={touched.currencyCode}
                width={18}
              />
            </div>
            <div className={styles.beside}>
              <MimaDateInput
                labelTitle="Reg Start Date"
                name="registrationStartDate"
                value={values.registrationStartDate}
                onChange={(text) => {
                  setFieldValue("registrationStartDate", text);
                }}
                showTimeSelect
                onBlur={handleBlur}
                width={18}
                touched={touched.registrationStartDate}
                error={errors.registrationStartDate}
              />

              <MimaDateInput
                labelTitle="Reg End Date"
                name="registrationEndDate"
                value={values.registrationEndDate}
                onChange={(text) => {
                  setFieldValue("registrationEndDate", text);
                }}
                onBlur={handleBlur}
                width={18}
                showTimeSelect
                touched={touched.registrationEndDate}
                error={errors.registrationEndDate}
              />
            </div>
            <div className={styles.beside}>
              <MimaDateInput
                labelTitle="Stage One Voting Start Date"
                name="stageOneVotingStartDate"
                value={values.stageOneVotingStartDate}
                onChange={(text) => {
                  setFieldValue("stageOneVotingStartDate", text);
                }}
                showTimeSelect
                onBlur={handleBlur}
                width={18}
                touched={touched.stageOneVotingStartDate}
                error={errors.stageOneVotingStartDate}
              />

              <MimaDateInput
                labelTitle="Stage One Voting End Date"
                name="stageOneVotingEndDate"
                value={values.stageOneVotingEndDate}
                onChange={(text) => {
                  setFieldValue("stageOneVotingEndDate", text);
                }}
                showTimeSelect
                onBlur={handleBlur}
                width={18}
                touched={touched.stageOneVotingEndDate}
                error={errors.stageOneVotingEndDate}
              />
            </div>
            <div className={styles.beside}>
              <MimaDateInput
                labelTitle="Stage Two Voting Start Date"
                name="stageTwoVotingStartDate"
                value={values.stageTwoVotingStartDate}
                onChange={(text) => {
                  setFieldValue("stageTwoVotingStartDate", text);
                }}
                onBlur={handleBlur}
                showTimeSelect
                width={18}
                touched={touched.stageTwoVotingStartDate}
                error={errors.stageTwoVotingStartDate}
              />

              <MimaDateInput
                labelTitle="Stage Two Voting End Date"
                name="stageTwoVotingEndDate"
                value={values.stageTwoVotingEndDate}
                onChange={(text) => {
                  setFieldValue("stageTwoVotingEndDate", text);
                }}
                onBlur={handleBlur}
                showTimeSelect
                width={18}
                touched={touched.stageTwoVotingEndDate}
                error={errors.stageTwoVotingEndDate}
              />
            </div>
            <div className={styles.beside}>
              <MimaInput
                labelTitle="Instagram Link"
                name="instagramLink"
                placeholder="Enter Link"
                value={values.instagramLink}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.instagramLink}
                touched={touched.instagramLink}
                width={18}
              />

              <MimaInput
                labelTitle="Twitter Link"
                name="twitterLink"
                placeholder="Enter Link"
                value={values.twitterLink}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.twitterLink}
                touched={touched.twitterLink}
                width={18}
              />
            </div>

            <div>
              <FieldArray
                name="prizes"
                render={(arrayHelpers) => (
                  <div>
                    <h2>Prizes</h2>
                    {values.prizes.map((prize, index) => (
                      <div key={index} className={styles.prizeContainer}>
                        {/* <MimaInput
                          labelTitle="Prize Number"
                          name={`prizes[${index}].prize`}
                          type="number"
                          value={prize.prize}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.prizes?.[index]?.prize}
                          touched={touched.prizes?.[index]?.prize}
                          width={18}
                        /> */}
                        <MimaInput
                          labelTitle="Prize Title"
                          name={`prizes[${index}].title`}
                          value={prize.title}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.prizes?.[index]?.title}
                          touched={touched.prizes?.[index]?.title}
                          placeholder="Enter Prize Title"
                        />
                        <div className={styles.beside}>
                          <MimaInput
                            labelTitle="Prize Key 1"
                            name={`prizes[${index}].prizeKey1`}
                            value={prize.prizeKey1}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.prizes?.[index]?.prizeKey1}
                            touched={touched.prizes?.[index]?.prizeKey1}
                            width={18}
                            placeholder="Enter Prize Key 1"
                          />
                          <MimaInput
                            labelTitle="Prize Value 1"
                            name={`prizes[${index}].prizeValue1`}
                            value={prize.prizeValue1}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.prizes?.[index]?.prizeValue1}
                            touched={touched.prizes?.[index]?.prizeValue1}
                            width={18}
                            placeholder="Enter Prize Value 1"
                          />
                        </div>
                        <div className={styles.beside}>
                          <MimaInput
                            labelTitle="Prize Key 2"
                            name={`prizes[${index}].prizeKey2`}
                            value={prize.prizeKey2}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.prizes?.[index]?.prizeKey2}
                            touched={touched.prizes?.[index]?.prizeKey2}
                            width={18}
                            placeholder="Enter Prize Key 2"
                          />
                          <MimaInput
                            labelTitle="Prize Value 2"
                            name={`prizes[${index}].prizeValue2`}
                            value={prize.prizeValue2}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.prizes?.[index]?.prizeValue2}
                            touched={touched.prizes?.[index]?.prizeValue2}
                            width={18}
                            placeholder="Enter Prize Value 2"
                          />
                        </div>

                        <div className={styles.beside}>
                          <MimaInput
                            labelTitle="Prize Key 3"
                            name={`prizes[${index}].prizeKey3`}
                            value={prize.prizeKey3}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.prizes?.[index]?.prizeKey3}
                            touched={touched.prizes?.[index]?.prizeKey3}
                            width={18}
                            placeholder="Enter Prize Key 3"
                          />

                          <MimaInput
                            labelTitle="Prize Value 3"
                            name={`prizes[${index}].prizeValue3`}
                            value={prize.prizeValue3}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.prizes?.[index]?.prizeValue3}
                            touched={touched.prizes?.[index]?.prizeValue3}
                            width={18}
                            placeholder="Enter Prize Value 3"
                          />
                        </div>
                        <div className={styles.buttonGroup}>
                          <MimaButton
                            title="Remove Prize"
                            onClick={() => arrayHelpers.remove(index)}
                            variant="text"
                            width={20}
                            mb={1}
                            titleColor="var(--color-error)"
                          />
                        </div>
                      </div>
                    ))}
                    <MimaButton
                      title="Add Prize"
                      onClick={() =>
                        arrayHelpers.push({
                          prize:
                            Math.max(...values.prizes.map((p) => p.prize), 0) +
                            1,
                          title: "",
                          prizeKey1: "",
                          prizeKey2: "",
                          prizeKey3: "",
                          prizeValue1: "",
                          prizeValue2: "",
                          prizeValue3: "",
                        })
                      }
                      buttonColor="var(--color-dark)"
                      width={24}
                    />
                  </div>
                )}
              />
            </div>

            <MimaDropdown
              labelTitle="Status"
              placeholder={selectedCompetition.status}
              name="status"
              data={statusData}
              value={values.status}
              id="status"
              onChange={(data) => {
                setFieldValue("status", data.key);
              }}
              error={errors.status}
              touched={touched.status}
              mt={1}
            />

            <MimaButton
              title="Save"
              mt={1}
              buttonColor="var(--color-dark-4)"
              onClick={handleSubmit}
              loading={loading}
              width={38}
            />
          </>
        )}
      </Formik>
    </Modal>
  );
};
export default EditCompetition;
